/**
 * Quantidade disponível: API pode enviar `stock` ou `countInStock`.
 */
export function getProductStockQuantity(product) {
  if (!product || typeof product !== 'object') return 0;
  const raw = product.stock ?? product.countInStock ?? 0;
  const n = Number(raw);
  return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
}

export function isProductOutOfStock(product) {
  return getProductStockQuantity(product) <= 0;
}
